// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 27) return "modules/modern_27-27.js?cacheBreaker=f783962679da33265a7a";
	if (chunkId === 77) return "modules/modern_77-77.js?cacheBreaker=4e36a65f56f5550a0f87";
	if (chunkId === 995) return "shell/modern_shell.js?cacheBreaker=302cae28fca8a5a2f6ea";
	if (chunkId === 329) return "modules/modern_329-329.js?cacheBreaker=e37342762587b4e4ced6";
	if (chunkId === 179) return "modules/modern_prismjs-179.js?cacheBreaker=aa7b1693bd1e1312ab9d";
	if (chunkId === 632) return "modules/modern_externalAuth-632.js?cacheBreaker=81fd5571196848898624";
	if (chunkId === 76) return "designer/modern_designer.js?cacheBreaker=d98b5fc0681a4aed67cf";
	if (chunkId === 517) return "modules/modern_calendar-517.js?cacheBreaker=c62b4ca0db0ea39b66f3";
	if (chunkId === 334) return "modules/modern_ui.ace-334.js?cacheBreaker=161a286b5cb1f9ce18bc";
	// return url for filenames based on template
	return undefined;
};